/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2022-12-27 17:24:07
 * @LastEditors: linxi
 * @LastEditTime: 2025-02-13 16:00:16
 */

import { nanoid, unwrapResult } from "@reduxjs/toolkit"
import {
  Button,
  Col,
  Dropdown,
  Form,
  Input,
  Menu,
  Modal,
  notification,
  Row,
  Select,
  Space,
  Table,
  Tag,
} from "antd"
import React, { ReactElement, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { selectUserId } from "../../app/applicationSlice"
import { RootDispatch } from "../../app/store"
import styles from "./QA.module.css"
import { Editor } from "@tinymce/tinymce-react"
import {
  createAnswerAsync,
  getAnswerListAsync,
  insertOrUpdateQuestionAsync,
  searchAnswerListAsync,
  updateFileAsync,
} from "./QASlice"
import { use } from "echarts"

interface configurationModelProps {
  visible: boolean
  updateDetail: any
  onCancel: () => void
  onOk: () => void
}
export const QACreateModel = ({
  visible,
  updateDetail,
  onCancel,
  onOk,
}: configurationModelProps): ReactElement => {
  const userId = useSelector(selectUserId)

  const [form] = Form.useForm()

  const [formAnswer] = Form.useForm()

  const { Option } = Select

  const dispatch = useDispatch<RootDispatch>()

  const [detail, setDetail] = useState<any>()

  const [data, setData] = useState<any>([])

  const [list, setList] = useState<any>([])

  const [answerModalVisible, setAnswerModalVisible] = useState(false)

  const [isVisible, setIsVisible] = useState(false)

  const [togetherVisible, setTogetherVisible] = useState(false)

  const [loading, setLoading] = useState(false)

  const [answerLoading, setAnswerLoading] = useState(false)

  const [ContentBody, setContentBody] = useState<any>()

  const [keyword, setKeyword] = useState<any>("")

  const [historyTitle, setHistoryTitle] = useState<any>("")

  const [historyList, setHistoryList] = useState<any>([])

  const [activeId, setActiveId] = useState<any>()

  const [updataId, setUpdataId] = useState<any>()

  const historyOverlay = (
    <Menu>
      {historyList.map((p: any) => (
        <Menu.Item
          key={p.id}
          onClick={() => {
            setActiveId(p.id)
            setHistoryTitle(p.title)
            setIsVisible(false)
          }}
        >
          <Space>
            <span>{p.title}</span>
          </Space>
        </Menu.Item>
      ))}
    </Menu>
  )

  const handleImageUpload: any = (blobInfo: any, progress: any) =>
    new Promise((resolve, reject) => {
      console.log(blobInfo.blob(), "blobInfo")
      const formData = new FormData()
      formData.append("file", blobInfo.blob())
      dispatch(updateFileAsync(formData))
        .then(unwrapResult)
        .then((v) => {
          let url = ""

          const hostname = window.location.hostname

          if (hostname.includes("test")) {
            url = "https://his.test.hydhis.com/proxyToOssHydhisPublic"
          } else if (
            hostname.includes("develop") ||
            hostname.includes("localhost")
          ) {
            url = "https://his.develop.hydhis.com/proxyToOssHydhisPublic"
          } else if (
            hostname.includes("36.213.47.39")
          ) {//无锡移动云
            url = "http://36.213.47.39:168/proxyToOssHydhisPublic"
          }else {
            url = "https://www.hydhis.cn/proxyToOssHydhisPublic"
          }
          resolve(url + v)
        })
        .catch(() => {
          reject("上传失败，请重新上传")
        })
    })

  // const changeHtmlContent = (type: number) => {
  //   const values = formAnswer.getFieldsValue()

  // }

  useEffect(() => {
    if (visible) {
      dispatch(
        searchAnswerListAsync({ str: historyTitle, current: 1, size: 10 })
      )
        .then(unwrapResult)
        .then((v: any) => {
          setHistoryList(v?.records)
        })
    } else {
      setList([])
      setData([])
    }
  }, [historyTitle, visible])

    useEffect(() => {
      if (visible) {
        if(updateDetail) {
          dispatch(getAnswerListAsync({ ids: updateDetail.answerId }))
            .then(unwrapResult)
            .then((res: any) => {
              form.setFieldsValue({
                questions: updateDetail.title,
              })
              setList(updateDetail.label?.split(','))
              setData(res.list)
            })
        }
      }
    }, [visible])

  return (
    <>
      <Modal
        title="新增QA"
        width={800}
        visible={visible}
        onCancel={() => {
          onCancel()
          form.resetFields()
        }}
        maskClosable={false}
        centered
        footer={null}
      >
        <Form
          className={styles.form}
          form={form}
          colon={false}
          onFinish={(values) => {
            if (!values?.questions) {
              notification.error({
                message: "请输入标题",
              })
              return
            }
            if (!list?.length) {
              notification.error({
                message: "请输入标签",
              })
              return
            }
            if (!data?.length) {
              notification.error({
                message: "请选择答案",
              })
              return
            }
            setLoading(true)
            dispatch(
              insertOrUpdateQuestionAsync({
                id: updateDetail?.id,
                questions: values?.questions,
                label: list?.join(","),
                answerId: data?.map((item: any) => item.id)?.join(","),
              })
            )
              .then(unwrapResult)
              .then(() => {
                notification.success({
                  message: "操作成功",
                })
                onOk()
                form.resetFields()
              })
              .catch(() => {
                onCancel()
                form.resetFields()
              }).finally(() => setLoading(false))
          }}
          labelCol={{
            span: 2,
          }}
          wrapperCol={{
            span: 22,
          }}
        >
          <Row>
            <Col span={24}>
              <Form.Item label="标题" name="questions">
                <Input placeholder="请输入" allowClear />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item label="标签">
                <Input
                  value={keyword}
                  allowClear
                  placeholder="新增标签"
                  onChange={(e: any) => {
                    setKeyword(e.target.value)
                  }}
                  onPressEnter={() => {
                    setList(list.concat(keyword))
                    setKeyword("")
                  }}
                  style={{ width: "50%" }}
                />
              </Form.Item>
            </Col>
          </Row>
          {list?.length > 0 && (
            <Row className={styles.tagList}>
              <Col span={2}></Col>
              <Col span={22} style={{ height: "56px" }}>
                {list?.map((v: any) => {
                  return (
                    <Tag
                      closable={true}
                      key={v}
                      onClose={() => {
                        setList(list.filter((item: any) => item !== v))
                      }}
                    >
                      {v}
                    </Tag>
                  )
                })}
              </Col>
            </Row>
          )}
          <Row>
            <Col span={24}>
              <Form.Item label="答案" name="modelVersion">
                <Row justify="space-between">
                  <Button
                    type="primary"
                    onClick={() => {
                      setUpdataId("")
                      setContentBody("")
                      formAnswer.setFieldsValue({
                        digest: "",
                        content: "",
                      })
                      setAnswerModalVisible(true)
                    }}
                  >
                    新增答案
                  </Button>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <Dropdown
                      overlay={historyOverlay}
                      trigger={["click"]}
                      visible={isVisible}
                      onVisibleChange={(v) => setIsVisible(v)}
                    >
                      <Input
                        placeholder="搜索历史答案"
                        style={{ width: "300px" }}
                        allowClear
                        value={historyTitle}
                        onChange={(e: any) => {
                          setHistoryTitle(e.target.value)
                        }}
                      />
                    </Dropdown>
                    <Button
                      type="primary"
                      onClick={() => {
                        const newData = historyList?.filter(
                          (item: any) => item.id == activeId
                        )
                        setData([...data, ...newData])
                        setHistoryTitle("")
                        setActiveId(null)
                      }}
                    >
                      引用答案
                    </Button>
                  </div>
                </Row>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={2}></Col>
            <Col span={22}>
              <Table
                dataSource={data}
                columns={[
                  {
                    title: "答案标题",
                    align: "left",
                    width: "80%",
                    ellipsis: true,
                    dataIndex: "title",
                  },
                  {
                    title: "操作",
                    align: "center",
                    width: "20%",
                    ellipsis: true,
                    render: function Element(_, m) {
                      return (
                        <Space>
                          <Button
                            type="link"
                            onClick={() => {
                              setUpdataId(m.id)
                              let url = ""
                              const hostname = window.location.hostname
                              if (hostname.includes("test")) {
                                url =
                                  "https://his.test.hydhis.com/proxyToOssHydhisPublic/"
                              } else if (
                                hostname.includes("develop") ||
                                hostname.includes("localhost")
                              ) {
                                url =
                                  "https://his.develop.hydhis.com/proxyToOssHydhisPublic/"
                              }  else if (
                                hostname.includes("36.213.47.39")
                              ) {//无锡移动云
                                url = "http://36.213.47.39:168/proxyToOssHydhisPublic"
                              }else {
                                url =
                                  "https://www.hydhis.cn/proxyToOssHydhisPublic/"
                              }
                              fetch(url + m.url)
                                .then((response) => response.text()) // 获取文本内容
                                .then((html) => {
                                  console.log(html)
                                  setContentBody(html)
                                  formAnswer.setFieldsValue({
                                    digest: m.title,
                                    content: html,
                                  })
                                  setAnswerModalVisible(true)
                                })
                                .catch((error) =>
                                  console.error("获取失败:", error)
                                )
                            }}
                          >
                            编辑
                          </Button>
                          <Button
                            type="link"
                            onClick={() => {
                              const newData = data.filter(
                                (item: any) => item.id !== m.id
                              )
                              setData([...newData])
                            }}
                          >
                            删除
                          </Button>
                        </Space>
                      )
                    },
                  },
                ]}
                rowKey={(t: any) => t.id}
                pagination={false}
                className={styles.QATable}
                style={{
                  overflowY: "auto",
                }}
              />
            </Col>
          </Row>
          <Row
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              marginTop: "20px",
            }}
          >
            <Space>
              <Button type="ghost" onClick={() => onCancel()}>
                取消
              </Button>
              <Button loading={loading} type="primary" onClick={() => form.submit()}>
                确定
              </Button>
            </Space>
          </Row>
        </Form>

        <Modal
          title={"添加答案"}
          width={800}
          maskClosable={false}
          visible={answerModalVisible}
          onCancel={() => setAnswerModalVisible(false)}
          footer={null}
        >
          <Form
            className={styles.form}
            form={formAnswer}
            colon={false}
            labelCol={{
              span: 2,
            }}
            wrapperCol={{
              span: 22,
            }}
            onFinish={(values) => {
              if (!ContentBody) {
                notification.error({
                  message: "请填写答案内容",
                })
                return
              }
              if (!values?.digest) {
                notification.error({
                  message: "请填写答案标题",
                })
                return
              }
              setAnswerLoading(true)
              const formData = new FormData()
              formData.append("html", ContentBody)
              dispatch(updateFileAsync(formData))
                .then(unwrapResult)
                .then((v) => {
                  dispatch(
                    createAnswerAsync({
                      id: updataId,
                      url: v,
                      digest: values.digest,
                    })
                  )
                    .then(unwrapResult)
                    .then((id) => {
                      setTogetherVisible(false)
                      setAnswerModalVisible(false)
                      if (updataId) {
                        setData(
                          data?.map((t: any) => {
                            return t.id != updataId
                              ? t
                              : {
                                  ...t,
                                  title: values.digest,
                                  url: v,
                                }
                          })
                        )
                      } else {
                        setData([
                          ...data,
                          { url: v, title: values.digest, id, html: "" },
                        ])
                      }
                    })
                    .finally(() => {
                      setAnswerLoading(false)
                    })
                })
            }}
          >
            <Row>
              <Col span={24}>
                <Form.Item label="答案标题" name="digest">
                  <Input placeholder="请输入" allowClear />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item label="答案内容" name="content">
                  <Editor
                    id={"tincyEditor"}
                    apiKey={"e5jnw6n73wxwfdr5c62ct24ewl8wgrfe6nfw8kgmpf42d9i2"}
                    value={ContentBody}
                    inline={false}
                    onChange={(e: any) => {
                      const value = e.level.content
                      setContentBody(value)
                    }}
                    init={{
                      selector: "#textarea" as any,
                      language: "zh_CN",
                      branding: false,
                      height: 500,
                      images_upload_handler: handleImageUpload,
                      convert_urls: false,
                      plugins:
                      'initEditor  preview searchreplace autolink directionality visualblocks visualchars fullscreen image link template code codesample table charmap hr pagebreak nonbreaking anchor insertdatetime advlist lists wordcount imagetools textpattern help emoticons autosave bdmap indent2em autoresize formatpainter axupimgs',
                    toolbar:
                      'code undo redo restoredraft | cut copy paste pastetext | forecolor backcolor bold italic underline strikethrough link anchor | alignleft aligncenter alignright alignjustify outdent indent | styleselect formatselect fontselect fontsizeselect | bullist numlist | blockquote subscript superscript removeformat | \
                    table image pageembed  charmap emoticons hr pagebreak insertdatetime  preview | fullscreen | bdmap indent2em lineheight formatpainter axupimgs',
                    toolbar_sticky: true,
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Space>
                <Button
                  type="ghost"
                  onClick={() => setAnswerModalVisible(false)}
                >
                  取消
                </Button>
                <Button type="primary" loading={answerLoading} onClick={() => formAnswer.submit()}>
                  确定
                </Button>
              </Space>
            </Row>
          </Form>
        </Modal>
      </Modal>
    </>
  )
}
